import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Row, Col, Select } from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Form, FormItem, InputItem, InputNumberItem, SelectItem, ButtonItem, CheckItem, ErrorItem } from "../../../../Components/Items";
import ModalItem from "../../../../Components/ModalItem";
import SelectInsumosItem from "../../../../Components/SelectInsumosItem";
import { unidadAMinutos, etiquetaUnidadTiempo } from "../../PresupuestosPU/OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";

const { Option } = Select;

const BOM_TEMPLATE = "46% 16% 16% 12% 10%";

class ModalGenerarMatriz extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    familias: [],
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.consultarFamilias();
    }
  }

  consultarFamilias() {
    axios
      .post("familias/selectFamilias", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => this.setState({ familias: Array.isArray(res.data) ? res.data : [] }))
      .catch(() => this.setState({ familias: [] }));
  }

  cerrar(matriz) {
    this.formRef.current?.resetFields();
    this.props.onCerrar(matriz);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/agregarMatrizRapida",
        {
          ...values,
          tiempoCiclo: unidadAMinutos(values.tiempoCiclo || 0, this.props.unidadTiempoProduccion),
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se generó la matriz");
          this.cerrar(res.data.matriz);
        } else {
          message.error(res.data.message || "No se pudo generar la matriz");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudo generar la matriz");
      });
  }

  render() {
    const unidadTiempo = etiquetaUnidadTiempo(this.props.unidadTiempoProduccion);

    return (
      <ModalItem
        title="Generar matriz"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrar()}
        onOk={() => this.formRef.current?.submit()}
        okText="Generar matriz"
        confirmLoading={this.state.loading}
        footer
        width="70%"
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="ModalGenerarMatriz"
          layoutForm="vertical"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={ErrorItem}
          initialValues={{ insumos: [{}] }}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <FormItem label="Descripción" name="descripcion" required margin>
                <InputItem placeholder="Descripción de la matriz" />
              </FormItem>
            </Col>
            <Col xs={24} md={6}>
              <FormItem label="Clave / No. de parte" name="clave" margin>
                <InputItem placeholder="Opcional" />
              </FormItem>
            </Col>
            <Col xs={24} md={6}>
              <FormItem label="Familia" name="familiaId" required margin>
                <SelectItem placeholder="Familia" width="100%">
                  {this.state.familias.map((familia) => (
                    <Option key={familia._id} value={familia._id}>
                      {familia.nombre}
                    </Option>
                  ))}
                </SelectItem>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={12} md={6}>
              <FormItem label="Piezas" name="piezas" required margin>
                <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} />
              </FormItem>
            </Col>
            <Col xs={12} md={6}>
              <FormItem label={`Tiempo ciclo (${unidadTiempo} por pieza)`} name="tiempoCiclo" margin>
                <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} />
              </FormItem>
            </Col>
          </Row>

          <div style={{ border: "1px solid #f0f0f0", borderRadius: 8, overflow: "hidden" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: BOM_TEMPLATE,
                gap: 6,
                padding: "8px 10px",
                background: "#fafafa",
                borderBottom: "1px solid #e8e8e8",
                fontSize: 12,
                fontWeight: 600,
                color: "#595959",
              }}
            >
              <span>Insumo o matriz</span>
              <span>Cantidad por pieza</span>
              <span>Medida (cm)</span>
              <span style={{ textAlign: "center" }}>Principal</span>
              <span />
            </div>
            <Form.List name="insumos">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, indice) => (
                    <div
                      key={key}
                      style={{
                        display: "grid",
                        gridTemplateColumns: BOM_TEMPLATE,
                        gap: 6,
                        alignItems: "center",
                        padding: "5px 10px",
                        borderBottom: "1px solid #f5f5f5",
                        background: indice % 2 === 1 ? "#fcfcfc" : "white",
                      }}
                    >
                      <FormItem {...restField} name={[name, "insumoId"]} required noStyle>
                        <SelectInsumosItem
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          tiposInsumos="generales"
                          placeholder="Insumo"
                          width="100%"
                          sinBorde
                          dropdownMatchSelectWidth={600}
                        />
                      </FormItem>
                      <FormItem {...restField} name={[name, "cantidad"]} required noStyle>
                        <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} />
                      </FormItem>
                      <FormItem {...restField} name={[name, "medida"]} noStyle>
                        <InputNumberItem placeholder="—" min={0} style={{ width: "100%" }} />
                      </FormItem>
                      <div style={{ textAlign: "center" }}>
                        <FormItem {...restField} name={[name, "principal"]} valuePropName="checked" noStyle>
                          <CheckItem />
                        </FormItem>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        {fields.length > 1 && (
                          <MinusCircleOutlined
                            style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                            onClick={() => remove(name)}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Agregar insumo
                  </ButtonItem>
                </>
              )}
            </Form.List>
          </div>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
});

export default connect(mapStateToProps)(ModalGenerarMatriz);
